import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  MotifButton,
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
} from '@ey-xd/motif-react';
import { CLEAR_API_ERROR } from '../../constants/reducerTypes';
import './errorModal.scss';

const ErrorModal = () => {
  const dispatch = useDispatch();
  const { showError, message = {} } = useSelector(state => state.errorData);
  const { header, info } = message;

  const handleClose = () => {
    document.body.style.overflow = '';   
    dispatch({ type: CLEAR_API_ERROR });
  };

  return (
    <>
      {showError && (
        <MotifModal className="error-modal" show={showError} onClose={handleClose}>
          <MotifModalHeader>
            <span className="modal-heading">{header || 'Connection Issue'}</span>
          </MotifModalHeader>
          <MotifModalBody>
            <p className="modal-message">
              {info || 'Something went wrong while fetching data. Please try again.'}
            </p>
          </MotifModalBody>
          <MotifModalFooter>
            <MotifButton onClick={handleClose} type="button" variant="secondary">
              Ok
            </MotifButton>
          </MotifModalFooter>
        </MotifModal>
      )}
    </>
  );
};

export default ErrorModal;
